import { render, staticRenderFns } from "./promoterLogin.vue?vue&type=template&id=1a809a57&scoped=true&"
import script from "./promoterLogin.vue?vue&type=script&lang=js&"
export * from "./promoterLogin.vue?vue&type=script&lang=js&"
import style0 from "./promoterLogin.vue?vue&type=style&index=0&id=1a809a57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a809a57",
  null
  
)

export default component.exports